// @ts-check
import GroupStatusIndicator from './GroupStatusIndicator';

export default GroupStatusIndicator;
